const ateProductForms = document.querySelectorAll('.ate__product_card_container form[action*=\'/cart/add\']');

ateProductForms.forEach(form => {
    console.log(form);
    const ateCartWrapper = document.getElementById("ate-cart");
    form.addEventListener("submit", function(e){

        fetch(`${window.location.origin}/cart.js`)
            .then(res => res.clone().json().then(data => {
                //.log("DATA", data);

                const newTotal = data.total_price/100;
                const newTotalTotal = newTotal.toLocaleString();
                const cart_items = data.items;
                data.items.forEach(item => {

                });

            })).finally( () =>{
            //console.log("cart finally");
        });
    });
});

const cartItemWrapper = document.getElementById("ate-cart");
cartItemWrapper.addEventListener("click", function(e){
    console.log(e);
    e.preventDefault();
    const target = e.target;
    const button = target.closest("cart-remove-button");

    fetch(`${window.location.origin}/cart/change?line=${button.getAttribute("data-index")}&quantity=0`);

    console.log(target.closest("cart-remove-button"));

});


class CartWatcher {
    init() {
        this.emitCartChanges().then(() => {
            this.observeCartChanges();
        });
    }

    async fetchCart() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    storeCart(cart) {
        localStorage.setItem('cart', JSON.stringify(cart));
    }

    storedCart() {
        return JSON.parse(localStorage.getItem('cart')) || { items: [] };
    }

    findCartChanges(oldCart, newCart) {
        const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
        let result = {
            added: onlyInLeft(newCart.items, oldCart.items),
            removed: onlyInLeft(oldCart.items, newCart.items),
        };

        oldCart.items.forEach(oi => {
            const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
            if (!ni) return;
            let quantity = ni.quantity - oi.quantity;
            let item = { ...ni };
            item.quantity = Math.abs(quantity);
            quantity > 0
                ? result.added.push(item)
                : result.removed.push(item)
        });

        return result;
    }

    async emitCartChanges() {
        const newCart = await this.fetchCart();
        const oldCart = this.storedCart();
        const changes = this.findCartChanges(oldCart, newCart);

        const event = new CustomEvent("cart_changed", { detail: changes });
        window.dispatchEvent(event);

        this.storeCart(newCart);
    }

    observeCartChanges() {
        const cartObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
                const isCartChangeRequest = /\/cart\//.test(entry.name);
                if (isValidRequestType && isCartChangeRequest) {
                    this.emitCartChanges();
                }
            });
        });
        cartObserver.observe({ entryTypes: ["resource"] });
    }
}

const myCartWatcher = new CartWatcher;
myCartWatcher.init();
//console.log("INIT CART LISTENER");

window.addEventListener("cart_changed", e => {
    console.log("CART CHANGED");
    const cart_container = document.getElementById("ate-cart");
    const template = document.getElementById('ate-cart-template');
    fetch(`${window.location.origin}/cart.js`)
        .then(res => res.clone().json().then(data => {
            console.log("DATA", data);

            cart_container.innerHTML = "";
            data.items.forEach(item => {
                //console.log(item);
                const itemRow = template.cloneNode(true);
                itemRow.classList.remove("hidden");
                const thumbnail = itemRow.querySelector(".ate__image");
                const title = itemRow.querySelector(".ate__title");
                const qty = itemRow.querySelector(".ate__quantity span");
                const price = itemRow.querySelector(".ate__price");

                thumbnail.setAttribute("src", item.image);
                title.innerHTML = item.product_title;
                qty.innerHTML = item.quantity;
                price.innerHTML = '$' + item.presentment_price + '/ea';
                //console.log(cart_container, itemRow);
                cart_container.appendChild(itemRow);
            });
            renderSubtotal(data.items_subtotal_price);

        })).finally( () =>{
    });
});

function renderSubtotal(subtotal){
    const subtotalWrappers = document.querySelectorAll(".ate__cart-subtotal");
    subtotalWrappers.forEach(el => {
        el.innerHTML = '$' + formatter.format(subtotal/100);
    });
    const threshold = document.getElementById("ate__free-ship-message");
    //calc the free ship threshold
    const freeShipLeft = threshold.getAttribute("data-threshold") * 100 - subtotal >= 1 ? (threshold.getAttribute("data-threshold") * 100 - subtotal) / 100 : null;
    if(freeShipLeft == null){
        threshold.innerHTML = "You qualify for free shipping.";
    } else {
        const fslDisplay = threshold.querySelector("span");
        threshold.innerHTML = '<strong>Add $' + formatter.format(freeShipLeft) + '</strong> more to qualify for free shipping';
    }
    renderProgressBar(subtotal, parseInt(threshold.getAttribute("data-threshold")));
}

function renderProgressBar(subtotal, threshold){
    const bar = document.getElementById("ate__progress_bar");
    const bar_pct = (subtotal / (threshold * 100)) >= 1 ? 100 : (subtotal / (threshold * 100)) * 100;
    bar.style.width = bar_pct + '%';
}